export default __webpack_public_path__ + "images/lodl_logo_full.svg";